import React, { Component } from 'react';
import { withTheme, withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

// ui/ux
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

// ours
import { uuidv4 } from '../../../../common';

const styles = (theme) => ({
  excerpt: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.getContrastText(theme.palette.primary.main),
    fontWeight: 'bold'
  },
  input: {
    '& .MuiFormLabel-root.Mui-focused': {
      color: theme.palette.text.secondary
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.text.secondary
    }
  },
  slimDivider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  }
});

class ReduceAnswers extends Component {
  constructor(props) {
    super(props);
    console.log('ReduceAnswers', JSON.stringify({ ...props, classes: null, theme: null, onComplete: null }));
    const { existingQuestion } = props;
    const numPossAns = existingQuestion.possible_values.length;

    const selectedIdx = this.suggestFromPossibleAnswers(0) || numPossAns;
    this.state = {
      id: uuidv4(),
      optsIdx: 0,
      selectedIdx,
      mapping: {},
      customMap: selectedIdx === numPossAns ? this.suggest(0) : ''
    };

    this.onRadioChange = this.onRadioChange.bind(this);
    this.next = this.next.bind(this);
  }
  suggest(i) {
    return this.props.formQuestion.opts[i].label;
  }
  componentDidMount() {
    const { optsIdx } = this.state;
    const { formQuestion, existingQuestion } = this.props;
    const currentAnswer = formQuestion.opts[optsIdx].value;
    const idx = existingQuestion.possible_values.indexOf(currentAnswer);
    if (idx > -1) {
      this.setState({
        selectedIdx: idx
      });
    }
  }
  componentDidUpdate() {}
  renderButtons(nextEnabled) {
    return (
      <Grid container justifyContent="flex-end" spacing={2}>
        <Grid item>
          <Button disabled={!nextEnabled} variant="outlined" color="secondary" onClick={this.next}>
            Next
          </Button>
        </Grid>
      </Grid>
    );
  }
  next() {
    const { existingQuestion, formQuestion, onComplete } = this.props;
    const { selectedIdx, optsIdx, customMap } = this.state;
    const currentAnswer = formQuestion.opts[optsIdx];
    const numPossAns = existingQuestion.possible_values.length;

    const mapping = {
      ...this.state.mapping,
      [currentAnswer.value]: selectedIdx === numPossAns ? customMap : existingQuestion.possible_values[selectedIdx]
    };

    // check for exit condition,
    if (optsIdx + 1 === formQuestion.opts.length) {
      return onComplete({ formQuestion, answerMapping: mapping, existingQuestion });
    }
    const newSelIdx = this.suggestFromPossibleAnswers(optsIdx + 1) || numPossAns;
    this.setState({
      mapping,
      optsIdx: optsIdx + 1,
      selectedIdx: newSelIdx,
      customMap: newSelIdx === numPossAns ? this.suggest(optsIdx + 1) : ''
    });
  }
  onRadioChange(e) {
    const selectedIdx = +e.target.value;
    this.setState({ selectedIdx });
  }
  formValid() {
    const { existingQuestion } = this.props;
    const { selectedIdx, customMap } = this.state;
    const { possible_values } = existingQuestion;
    const numPossAns = possible_values.length;

    return (selectedIdx !== null && selectedIdx < numPossAns) || (selectedIdx === numPossAns && customMap.length > 0);
  }
  suggestFromPossibleAnswers(optIdx) {
    const { formQuestion, existingQuestion } = this.props;
    const nextOpt = formQuestion.opts[optIdx].label.toLowerCase();
    const poss = existingQuestion.possible_values.map((d) => d.toLowerCase());
    const idx = poss.indexOf(nextOpt);
    return idx > -1 ? idx : null;
  }
  render() {
    const { classes, formQuestion, existingQuestion } = this.props;
    const { optsIdx, selectedIdx, id, customMap } = this.state;
    const { possible_values } = existingQuestion;
    const numPossAns = possible_values.length;
    const currentAnswer = formQuestion.opts[optsIdx];
    const formValid = this.formValid();
    return (
      <React.Fragment>
        <Typography>
          {'Does this answer, "'}
          <span className={classes.excerpt}>{currentAnswer.label}</span>
          {'", correlate to any of the existing answers to this question?'}
        </Typography>
        {this.renderButtons(formValid)}
        <FormControl component="fieldset">
          <RadioGroup id={`rg-selanswers-${id}`} value={selectedIdx} name="rg-selanswers" onChange={this.onRadioChange}>
            {possible_values.map((d, i) => (
              <FormControlLabel key={d} value={i} control={<Radio />} label={d} />
            ))}
            <Divider variant="middle" className={classes.slimDivider} />
            <Grid container direction="row" justifyContent="center" alignItems="center">
              <Grid item>
                <FormControlLabel value={numPossAns} control={<Radio />} />
              </Grid>
              <Grid item>
                <TextField
                  onClick={() => {
                    this.setState({
                      selectedIdx: numPossAns
                    });
                  }}
                  error={selectedIdx === numPossAns && customMap.length === 0}
                  value={customMap}
                  style={{ width: '30vw' }}
                  className={classes.input}
                  size="small"
                  label="New Mapping"
                  placeholder="🚒  Very Safe"
                  onChange={(e) => {
                    this.setState({
                      customMap: e.target.value,
                      selectedIdx: numPossAns
                    });
                  }}
                />
                <Typography style={{ display: 'block' }} variant="caption">
                  This key will propagate to the user interface and should be user friendly.
                </Typography>
              </Grid>
            </Grid>
          </RadioGroup>
        </FormControl>
        {this.renderButtons(formValid)}
      </React.Fragment>
    );
  }
}

ReduceAnswers.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,

  onComplete: PropTypes.func.isRequired,

  existingQuestion: PropTypes.object.isRequired,
  formQuestion: PropTypes.object.isRequired
};

ReduceAnswers.defaultProps = {};

export default withTheme(withStyles(styles)(ReduceAnswers));
